/*
 * Copyright (c) GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import {Component} from '@angular/core';
import {FabThemeService} from '@fabric/components/theme';
import {UserService} from '../core/user/user.service';
import {AuthenticationService} from '../core/authentication/authentication.service';

@Component({
    selector: 'app-getting-started-guide',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss'],
})
export class HomeComponent {
    constructor(
        public readonly themeService: FabThemeService,
        public readonly userService: UserService,
        public readonly authService: AuthenticationService
    ) {
    }
}
